module.exports = __webpack_public_path__ + "fonts/fa-brands-400.fe6bd13bde2372904e439f0539642e64.woff";